import { useTranslation } from 'react-i18next'

/**
 * Site footer: the decorative futhark row and the legal line every page must carry
 * (fan project, no Jagex affiliation, demo data).
 */
export function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="border-t border-steel/15 px-5 pt-10 pb-14 text-center">
      <div aria-hidden="true" className="font-runic text-sm tracking-futhark text-rune/40">
        {t('footer.futhark')}
      </div>
      <p className="mx-auto mt-3 max-w-xl text-xs/relaxed text-mist/70">{t('footer.legal')}</p>
    </footer>
  )
}
